// export const urlbase = "https://localhost:7216";
export const urlbase = "http://larosalinaapi.ezequielsirne.ar";
